import { createFileRoute } from '@tanstack/react-router'

import { BrandCampaignLanding, brandCampaignHead, loadBrandCampaign } from '../components/BrandCampaignLanding'
import { getBrandCampaign } from '../data/brandCampaigns'

const campaign = getBrandCampaign('masker-onemed')!

export const Route = createFileRoute('/masker-onemed')({
  loader: () => loadBrandCampaign(campaign),
  head: () => brandCampaignHead(campaign),
  component: MaskerOneMedPage,
})

function MaskerOneMedPage() {
  return <BrandCampaignLanding data={Route.useLoaderData()} />
}
